export const GET_NEWS= 'GET_NEWS';
export const GET_NEWS_ERR = 'GET_NEWS_ERR';

export const GET_ALLNEWS= 'GET_ALLNEWS';
export const GET_ALLNEWS_ERR = 'GET_ALLNEWS_ERR';

export const CREATE_NEWS= 'CREATE_NEWS';
export const CREATE_NEWS_ERR = 'CREATE_NEWS_ERR';